import { displayGet, displayJson, displayDelete } from '../../../services/displayApi';

export interface DisplayTimeSlotApi {
  weekday: string;
  start_time: string;
  end_time: string;
}

export interface DisplaySaveAttributeApi {
  mode: 'S' | 'P';
  mediaId?: string;
  playlistId?: string;
  fallbackMediaId: string;
  orientation: 'LANDSCAPE' | 'PORTRAIT';
  heartbeatInterval?: number | null;
  timeSlots: DisplayTimeSlotApi[];
}

export interface DisplaySavePayload {
  locationId: string;
  templateType: 'MEDIA';
  displayName: string;
  attribute: DisplaySaveAttributeApi;
}

export interface DisplaySpotlightMediaApi {
  mediaId: string;
  name: string;
  mimeType: string;
  url: string;
  orientation: 'LANDSCAPE' | 'PORTRAIT';
  sequenceNo: string;
  displayTime: string;
  showTime: DisplayTimeSlotApi[];
}

export interface DisplayAttributeApi {
  mode?: 'S' | 'P';
  playlistId?: string;
  orientation?: 'LANDSCAPE' | 'PORTRAIT' | null;
  heartbeatInterval?: number | null;
  timeSlots?: DisplayTimeSlotApi[];
  spotLightMedia?: DisplaySpotlightMediaApi[];
  fallbackMedia?: DisplaySpotlightMediaApi | null;
}

export interface DisplayApiItem {
  id: string;
  templateId: string;
  locationId: string;
  name: string;
  displayName: string;
  secretKey: string;
  templateType: string;
  isDeleted: boolean;
  attribute: DisplayAttributeApi;
  createdTime: string;
  modifiedTime: string;
}

/** Create/update response body: { message, displayId, pin, data }. displayJson wraps this once
 *  more as { data: rawBody } — callers read res.data for this shape, res.data.data for the item. */
export interface DisplaySaveApiResponse {
  message: string;
  displayId: string;
  pin: string;
  data: DisplayApiItem;
}

/** POST {DISPLAY_BASE}/display/template */
export const createDisplayApi = (payload: DisplaySavePayload) =>
  displayJson('/display/template', payload, 'POST') as Promise<{ data: DisplaySaveApiResponse }>;

/** POST {DISPLAY_BASE}/display/template/{id} — update uses POST, not PATCH; the display id comes
 *  from the URL, never from the body. */
export const updateDisplayApi = (id: string, payload: DisplaySavePayload) =>
  displayJson(`/display/template/${encodeURIComponent(id)}`, payload, 'POST') as Promise<{ data: DisplaySaveApiResponse }>;

/** GET {DISPLAY_BASE}/display?locationId=&search= — response body is a bare array, not { data: [...] }. */
export const fetchDisplaysApi = (locationId: string, search?: string) =>
  displayGet(`/display?${new URLSearchParams({ locationId, ...(search ? { search } : {}) }).toString()}`) as Promise<{ data: DisplayApiItem[] }>;

export interface DisplayDeleteApiResponse {
  id: string;
  deleted: boolean;
}

/** DELETE {DISPLAY_BASE}/display/{id}?locationId= — soft delete (mh_display.is_deleted = 1). */
export const deleteDisplayApi = (id: string, locationId: string) =>
  displayDelete(`/display/${encodeURIComponent(id)}?${new URLSearchParams({ locationId }).toString()}`, 'Failed to delete display') as Promise<{ data: { data: DisplayDeleteApiResponse; message?: string } }>;
